import React from "react";

import {Col, Divider, Row, Statistic} from "antd";

import {DataCard} from "../../components/helpers/cards/Card";
import {projectCurrency, properties} from "../../properties";

function Dashboard({stat}) {
	return (
		<Row>
			<Col span={8}>
				<Statistic title={"Materials"} value={stat.total} />
			</Col>
			<Col span={8}>
				<Statistic title={"Stocked"} value={stat.stocked} />
			</Col>
			<Col span={8}>
				<Statistic title={`Value (${projectCurrency})`} value={stat.value} suffix={stat.suffix} />
			</Col>
		</Row>
	);
}

export class StaticDashboardOld extends React.Component {
	render() {
		return (
			<div style={{padding: 10}}>
				<Row>
					<Col span={4} />
					<Col span={16}>
						<DataCard title={"Inventory Status"}>
							<Dashboard
								stat={{
									total: 24342,
									stocked: 8101,
									value: 18.72,
									suffix: "m",
								}}
							/>
						</DataCard>
					</Col>
					<Col span={4}></Col>
				</Row>
				<Row style={{padding: 10}}>
					<Divider
						type="horizontal"
						orientation="center"
						style={{opacity: 0.5, backgroundColor: properties.kbrColors.pantone301Blue}}
					/>
				</Row>
				<Row>
					<Col span={8} style={{padding: 10}}>
						<DataCard title={"Potential Duplicates"}>
							<Dashboard
								stat={{
									total: 2433,
									stocked: 861,
									value: 2.7,
									suffix: "m",
								}}
							/>
						</DataCard>
					</Col>
					<Col span={8} style={{padding: 10}}>
						<DataCard title={"Potential Obsoletes"}>
							<Dashboard
								stat={{
									total: 18712,
									stocked: 5156,
									value: 7.65,
									suffix: "m",
								}}
							/>
						</DataCard>
					</Col>
					<Col span={8} style={{padding: 10}}>
						<DataCard title={"Insurance Spares"}>
							<Dashboard
								stat={{
									total: 3,
									stocked: 3,
									value: 387.41,
									suffix: "K",
								}}
							/>
						</DataCard>
					</Col>
				</Row>
				<Row>
					<Col span={4} />
					<Col span={8} style={{padding: 10}}>
						<DataCard title={"No-BOM Materials"}>
							<Dashboard
								stat={{
									total: 12834,
									stocked: 2883,
									value: 5.21,
									suffix: "m",
								}}
							/>
						</DataCard>
					</Col>
					<Col span={8} style={{padding: 10}}>
						<DataCard title={"Slow-Moving Materials"}>
							<Dashboard
								stat={{
									total: 22095,
									stocked: 6970,
									value: 14.67,
									suffix: "m",
								}}
							/>
						</DataCard>
					</Col>
					<Col span={4} />
				</Row>
			</div>
		);
	}
}
